import { render } from "./AgroShopDashboard.vue?vue&type=template&id=2aa3f118&scoped=true"
import script from "./AgroShopDashboard.vue?vue&type=script&lang=js"
export * from "./AgroShopDashboard.vue?vue&type=script&lang=js"

import "./AgroShopDashboard.vue?vue&type=style&index=0&id=2aa3f118&lang=css"
import "./AgroShopDashboard.vue?vue&type=style&index=1&id=2aa3f118&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa3f118"]])

export default __exports__